/*
 * Copyright (c) 2026 Bolmate B.V.
 */

import IDate from '@dvrd/idate';

import {addLocale, locale} from 'primereact/api';

import {AppLanguage, normalizeLanguage} from './config';

let registeredLocales = false;

function registerPrimeLocales() {
    if (registeredLocales) return;
    addLocale('nl', {
        accept: 'Accepteren',
        addRule: 'Filter toevoegen',
        apply: 'Toepassen',
        cancel: 'Annuleren',
        matchAll: 'Alle',
        contains: 'Bevat',
        notContains: 'Bevat niet',
        clear: 'Wissen',
        startsWith: 'Begint met',
        endsWith: 'Eindigt met',
        matchAny: 'Match elke',
        equals: 'Gelijk aan',
        notEquals: 'Niet gelijk aan',
        gt: 'Meer dan',
        gte: 'Meer of gelijk aan',
        lt: 'Minder dan',
        lte: 'Minder of gelijk aan'
    });
    addLocale('en', {
        accept: 'Accept',
        addRule: 'Add filter',
        apply: 'Apply',
        cancel: 'Cancel',
        matchAll: 'All',
        contains: 'Contains',
        notContains: 'Does not contain',
        clear: 'Clear',
        startsWith: 'Starts with',
        endsWith: 'Ends with',
        matchAny: 'Match any',
        equals: 'Equals',
        notEquals: 'Not equals',
        gt: 'Greater than',
        gte: 'Greater than or equal',
        lt: 'Less than',
        lte: 'Less than or equal'
    });
    registeredLocales = true;
}

export function applyRuntimeLocale(language: string | AppLanguage) {
    registerPrimeLocales();
    const normalized = normalizeLanguage(language);
    if (normalized === 'en') {
        // Use en-GB, not en-US: IDate.format() derives its Intl.DateTimeFormat
        // options from the format tokens but never forces hour12, so the clock
        // convention follows the locale default. en-US defaults to a 12-hour
        // clock, which turns our `HH:mm` tokens (24-hour by intent, e.g. the
        // order card time) into "05:48" instead of "17:48". en-GB keeps the
        // English month/weekday names while defaulting to the 24-hour clock and
        // DD/MM date order the rest of the app already uses.
        IDate.setLocale('en-GB');
    } else {
        IDate.setLocale('nl-NL');
    }
    locale(normalized);
    document.documentElement.lang = normalized;
}
